import { Box } from "@mui/material";
import { PickersActionBarProps } from "@mui/x-date-pickers/PickersActionBar";
import { ActionButton } from "../Button";


interface IActionBarProps extends PickersActionBarProps {
    showClearButton?: boolean;
}


const ActionBar: React.FC<IActionBarProps> = ({
    onCancel,
    onAccept,
    onClear,
    showClearButton = false
}) => {
    return <Box className='display-flex justifycontent-spacebetween alignitems-center' padding={2}>
        <Box className='datefield-actionbar'>
            <ActionButton
                action="cancel" 
                onClick={onCancel} 
                className='icon-only'
            />

            {
                showClearButton && <ActionButton 
                    action='clear'
                    onClick={onClear} 
                    className='icon-only'
                />
            }
        </Box>

        <ActionButton 
            action='save'
            onClick={onAccept} 
            className='icon-only'
        />
    </Box>;
}


export default ActionBar;